import { React } from 'react';
import { ReactDOM } from 'react-dom/client';

function Purpose (){
    return(
        <div>
            <p>For this website, I have catalloged
                a variety of programming languages,
                including their strengths, their weaknesses,
                and their main applications. This website has
                been built using React.js to serve as the frontend
                and Django to maintain a feed of articles on
                the backend.
            </p>
        </div>
    );
}

export default Purpose;